import { RsValue } from '../../../models/base/BaseModel';
import {
  IHospitalParam,
  IHospitalResult,
  ITag,
  ITagNumberColor,
} from '../../../models/hospital/HospitalModel';
import api from '../../axios';

export const hospitalService = {
  listAllHospitals: (): Promise<IHospitalResult[]> => api.get('/Hospital'),
  listAllHospitalsWithOData: (odata: any): Promise<IHospitalResult[]> =>
    api.get('odata/Hospital', odata),
  newHospital: (data: IHospitalParam): Promise<RsValue<any>> => api.post('/Hospital', data),
  updateHospital: (id: number, data: IHospitalParam): Promise<RsValue<any>> =>
    api.put(`/Hospital/${id}`, data),
  addHospitalTagPrefix: (params: { hospitalId: number; prefix: string }): Promise<RsValue<any>> =>
    api.post('/Hospital/tag-prefix', params),
  getTagsByHospitalId: (hospitalId: number): Promise<ITag[]> =>
    api.get(`/Hospital/${hospitalId}/tags`),
  // Fetch tag number colors for a specific tag (color -> sequence list)
  getTagColorsByTagId: (tagId: number): Promise<ITagNumberColor[]> =>
    api.get(`/Hospital/tag-colors/${tagId}`),
  delete: (id: number): Promise<RsValue<boolean>> => api.delete(`Hospital/${id}`),
};

// SignalR hub URL env üzerinden okunuyor (see services/signalr.ts)
